import Audit from './index'
import Withdrawal from './Withdrawal'
import KYC from './KYC'
import C2C from './C2C'
import OTC from './OTC'
import logLimit from './logLimit'
import Merchant from './Merchant'
import c2cAll from './c2cAll'
import Transfer from './Transfer'
import Deposite from './Deposite'
import DepositeRecords from './DepositeRecords'
import CashOut from './CashOut'
import Feedback from './Feedback'
import WithdrawRecords from './WithdrawRecords'
import OtcDeposite from './otcDeposite'
import OtcWithdraw from './otcWithdraw'
import OtcBuyLimit from './otcBuyLimit'
import AuthLimit from './authLimit'
export default {
  path: '/home/audit',
  component: Audit,
  redirect: '/home/audit/withdrawal',
  children: [
    { path: '/home/audit/withdrawal', component: Withdrawal },
    { path: '/home/audit/kyc', component: KYC },
    { path: '/home/audit/C2C', component: C2C },
    { path: '/home/audit/otc', component: OTC },
    { path: '/home/audit/logLimit', component: logLimit },
    { path: '/home/audit/merchant', component: Merchant },
    { path: '/home/audit/c2cAll', component: c2cAll },
    { path: '/home/audit/transfer', component: Transfer },
    { path: '/home/audit/deposite', component: Deposite },
    { path: '/home/audit/feedback', component: Feedback },
    { path: '/home/audit/cashOut', component: CashOut },
    { path: '/home/audit/deposite/records', component: DepositeRecords },
    { path: '/home/audit/withdraw/records', component: WithdrawRecords },
    { path: '/home/audit/otcwithdraw', component: OtcWithdraw },
    { path: '/home/audit/otcdeposite', component: OtcDeposite },
    { path: '/home/audit/otcBuyLimit', component: OtcBuyLimit },
    { path: '/home/audit/authLimit', component: AuthLimit },
  ],
}
